<div [class.stat-card--compact]="isCompact()" class="stat-card">
    <div class="section-label stat-card-label">
        {{ label }}
        @if (tooltipText()) {
            <i [attr.aria-label]="label + ': ' + tooltipText()"
               [pTooltip]="tooltipText()"
               class="fa fa-info-circle stat-card-info"
               infoTip></i>
        }
    </div>
    <div class="stat-card-value">
        @if (unavailable) {
            <span class="data-unavailable">{{ unavailableText }}</span>
        } @else {
            {{ value }}
        }
    </div>
    @if (!unavailable && description) {
        <div class="stat-card-description">{{ description }}</div>
    }
</div>
